import * as React from "react";
import * as Yup from "yup";

const useYupValidationResolver = (validationSchema: Yup.AnySchema) =>
  React.useCallback(
    async (data: any) => {
      try {
        const values = await validationSchema.validate(data, {
          abortEarly: false,
        });
        return {
          values,
          errors: {},
        };
      } catch (errors: any) {
        return {
          values: {},
          errors: errors.inner.reduce(
            (
              allErrors: Record<any, Yup.ValidationError>,
              currentError: Yup.ValidationError
            ) => ({
              ...allErrors,
              [currentError.path || "no path"]: {
                type: currentError.type ?? "validation",
                message: currentError.message,
              },
            }),
            {}
          ),
        };
      }
    },
    [validationSchema]
  );

export default useYupValidationResolver;
